import { AxiosRequestConfig } from 'axios'
import axiosInstance from '../axiosInstance'

export const register = async (name: string, email: string, password: string, passwordConfirmation: string): Promise<void> => {
    const params = {
        name,
        email,
        password,
        password_confirmation: passwordConfirmation,
    }

    await axiosInstance.post('register', params)
}

export const login = async (email: string, password: string, config?: AxiosRequestConfig): Promise<{ two_factor: boolean }> => {
    const params = {
        email,
        password,
        user_type: 'admin',
    }

    const response = await axiosInstance.post('login', params, config)

    return {
        two_factor: response.data.two_factor || false,
    }
}

export const logout = async (config?: AxiosRequestConfig): Promise<void> => {
    await axiosInstance.post('logout', undefined, config)
}

export const twoFactorChallenge = async (code: string, config?: AxiosRequestConfig): Promise<void> => {
    const data = {
        code,
    }

    await axiosInstance.post('two-factor-challenge', data, config)
}

export const forgotPassword = async (email: string): Promise<void> => {
    await axiosInstance.post('forgot-password', { email })
}

export const resetPassword = async (email: string, token: string, password: string, passwordConfirmation: string): Promise<void> => {
    await axiosInstance.post('reset-password', { email, token, password, password_confirmation: passwordConfirmation })
}

export const changePassword = async (form: { currentPassword: string, password: string, passwordConfirmation: string }): Promise<void> => {
    await axiosInstance.put('user/password', { current_password: form.currentPassword, password: form.password, password_confirmation: form.passwordConfirmation })
}